import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
  IonList,
  IonLoading,
  IonItem,
  IonText,
  IonLabel,
  IonTextarea,
  useIonViewWillEnter,
  useIonViewDidEnter,
  IonButton,
  IonToast,
} from "@ionic/react";
import React, { useState } from "react";
import FaqItem from "../../../components/faqs/FaqItem";
import { useParams } from "react-router";
import axios from "axios";
import { requestID, baseUrl, config, getShopDetails } from "../../../common/utils";
import { useQuery } from "react-query";
import classes from "./AdminDashboard.module.css";
import { arrowBack } from "ionicons/icons";

const AdminTerms = () => {
  const [status, setStatus] = useState({ loading: false, error: false });
  const [adminTerms, setAdminTerms] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);

  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const handleSave = () => {
    var terms1 = document.getElementById("terms1");
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("termsandconditions", terms1.value);
        formData.append("terms_id", term_id);


    setStatus({ loading: true, error: false });

    axios
      .post(baseUrl() + "Faqsandterms/editterms_saas", formData, config)
      .then((response) => {
        console.log(response);

        //setSellerTerms(response.data.data);
        getAdminTerms();
        //setSellerTermsx(response.data.data);
        setErrorLogin(response.data.message);
        callToast();
        setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        setStatus({ loading: false, error: true });
        // throw new error("hey ");
      });
  };

  const [term_id, setTerm_id] = useState("");
  const getAdminTerms = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());

    setStatus({ loading: true, error: false });

    axios
      .post(baseUrl() + "Faqsandterms/getAdminTerms_saas", formData, config)
      .then((response) => {
        console.log(response);
        console.log(response.data.data.terms_conditions);
        setAdminTerms(response.data.data.terms_conditions);
        setTerm_id(response.data.data.terms_id);
        //setSellerTermsx(response.data.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  useIonViewWillEnter(() => {
    getAdminTerms();
  });

  /*  useIonViewDidEnter(() => {
    console.log("sds2");
    getSellerTerms();
  }); */
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>
        <IonButtons slot="">
            <IonBackButton text="" icon={arrowBack} className="zillytheme2" />
          </IonButtons>
          <IonTitle>Terms and Conditions</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem lines="none">
            <IonTextarea
              id="terms1"
              className={` zillyBoxc " ${classes.termsBg}`}
              rows="25"
              shape="round"
              spellcheck={true}
              counter={true}
              maxlength="1000"
              placeholder="Enter Admin terms and condition here"
              autoGrow={true}
              value={adminTerms}
              onIonChange={(e) => {
                setAdminTerms(e.detail.value);
              }}
            ></IonTextarea>
          </IonItem>

          {/* <IonItem
            className="zillyItemx"
            detail={false}
            lines="none"
            routerLink="/seller/sellerDashboard"
          >
            <IonButton
              color="warning"
              mode="md"
              size="large"
              className="zillyButtonx"
              fill="solid"
              onClick={handleSave}
            >
              Save
            </IonButton>
          </IonItem> */}
        </IonList>
        <IonItem className="zillyItemx" detail={false} lines="none">
          <IonButton
            color="warning"
            mode="md"
         
            size="large"
            className="zillyButtonx"
            fill="solid"
            onClick={handleSave}
          >
            Save
          </IonButton>
        </IonItem>
      </IonContent>
      {status.error && (
        <IonToast position="middle" isOpen={showToast} message={errorLogin} />
      )}
      <IonLoading isOpen={status.loading} />
    </IonPage>
  );
};

export default AdminTerms;
